import { get, post, put } from "../utils/http";

/**
 * 获取旅游路线列表
 * @param {Object} params - 查询参数
 * @param {string} params.status - 状态筛选：all/1/2/3
 * @param {string} params.search - 搜索关键词
 * @param {number} params.page - 页码
 * @param {number} params.page_size - 每页条数
 * @returns {Promise}
 */
export const getTravelRoutes = (params) => {
  return get("/travel/travel_routes", params);
};

/**
 * 切换路线启用/禁用状态
 * @param {number} id - 路线ID
 * @param {number} status - 目标状态：1=启用，0=禁用
 * @returns {Promise}
 */
export const toggleRouteStatus = (id, status) => {
  return put(`/travel/travel_routes/status/${id}`, { status });
};

/**
 * 获取单个路线详情
 * @param {number} id - 路线ID
 * @returns {Promise}
 */
export const getTravelRouteDetail = (id) => {
  return get(`/travel/travel-routes/${id}`);
};

/**
 * 添加新路线
 * @param {Object} data - 路线信息
 * @returns {Promise}
 */
export const addTravelRoute = (data) => {
  return post("/travel/travel-routes", data);
};

/**
 * 更新路线信息
 * @param {number} id - 路线ID
 * @param {Object} data - 路线信息
 * @returns {Promise}
 */
export const updateTravelRoute = (id, data) => {
  return put(`/travel/travel-routes/${id}`, data);
};
